import React from 'react';
import NotFound from '../Screens/Errores/NotFound'; // 404
import Empty from '../Screens/Errores/Empty';
import PantallaPrincipalAtlas from '../Screens/PantallaPrincipalAtlas/components/PantallaPrincipalAtlas.jsx';
import NuevaInstanciaParametro from '../Screens/NuevaInstanciaParametro/components/Container.jsx';
import ListadoParametros from '../Screens/ListadoParametros/components/Container.jsx';
import VistaInstanciaParametro from '../Screens/VistaInstanciaParametro/components/Container.jsx';

const PaginaInicial = () => {return (<div></div>);} 
const ApplicationRoutes = {Routes: [ 
    {path: "/Atlas/",exact: true,component: PantallaPrincipalAtlas,isPrivate: true},
    {path: "/:product/:category/:program/NuevaInstanciaParametro/:id?",exact: true,component: NuevaInstanciaParametro,isPrivate: true},
    {path: "/:product/:category/:program/ListadoParametros/:id?",exact: true,component: ListadoParametros,isPrivate: true},
    {path: "/:product/:category/:program/VistaInstanciaParametro/:id?",exact: true,component: VistaInstanciaParametro,isPrivate: true},
    {path: "/Atlas/:category/:program/InvocadorReportes",exact: true,component: Empty,isPrivate: true},
    {path: "/Atlas/", exact: false, component: NotFound}
]};
export default ApplicationRoutes;